<script setup lang="ts">

import { formatDate, currency } from "@library/Utilities";
import type { ICarbucksProfile } from "@domain/Carbucks";
import { TransactionRows } from ".";

const model = defineModel<ICarbucksProfile>( { required: true } );

</script>

<template>

    <div class="tracking-wider">
        
        <h1 class="text-base lg:text-lg 3xl:text-xl pt-6 pb-3 px-4
                   bg-gradient-to-b from-gray-850 to-gray-850/60 -mb-px">
            Pending Transactions
        </h1>

        <div class="w-full h-max table overflow-hidden">

            <div class="bg-gray-850">
                <TransactionRows :transactions="model.pendingTransactions" showCashbackOnly>
                    <template #amountHeader>Pending Amount</template>
                </TransactionRows>

                <div v-if="model.pendingTransactions.length == 0"
                    class="py-4 px-4 lg:px-6 bg-gray-100/10 dark:bg-gray-850 text-base 3xl:text-lg">
                    You have no pending transactions
                </div>
                
                <div class="w-full flex flex-col items-center gap-4 pt-2 3xl:pt-6 pb-6
                            bg-gray-100/20 dark:bg-gray-850">
                    <Button variant="tonal"
                            class="!h-10 lg:!h-11 3xl:!h-12 rounded-lg"
                            :to="`/carbucks/transactions`">
                        Transaction History
                        <Icon name="arrow-right" class="ml-2" />
                    </Button>
                </div>
            </div>
            
        </div>

    </div>

</template>